import { JSConn } from "@/utilities/js-conn";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";

export default {
  name: "clientShow",
  components: {
    LoadingAnimation,
  },
  props: {
    clientId: String,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading Client...",
      sortBy: "name",
      workOrdersSortBy: "name",
      clientFieldsFields: [
        { key: "name", label: "Name", sortable: true },
        { key: "acres", label: "Acres", sortable: true },
        { key: "commodity", label: "Commodity", sortable: true },
        { key: "actions", label: "Actions", sortable: false },
      ],
      workOrderFields: [
        { key: "name", label: "Name", sortable: true },
        { key: "description", label: "Description", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "actions", label: "Actions", sortable: false },
      ],
    };
  },
  computed: {
    client: function() {
      return this.$store.getters.client;
    },
    firstPhoneNumber: function() {
      if (this.client.phone_numbers.length > 0) {
        return this.client.phone_numbers[0];
      } else {
        return {
          number: "000000000",
        };
      }
    },
  },
  created() {
    const jsConn = new JSConn();

    jsConn.formParams = {
      id: this.clientId,
    };

    this.$store.dispatch("needClient", jsConn).then(() => {
      this.dataLoaded = true;
    });
  },
};
